import env from "../app/Environment";
import fetchService from "../utils/FetchService";
import { InvitationResult } from "../utils/invitationStatus";

export interface ResendInvitationsResponse {
  invitations: InvitationResult[];
}

export class InvitationService {
  constructor(private endpoint: string) {}

  async resend(emails: string[]): Promise<ResendInvitationsResponse> {
    return fetchService
      .fetch(`${this.endpoint}/invitations/resend`, {
        method: "POST",
        body: JSON.stringify({ emails }),
      })
      .then((r) => r.json());
  }
}

const service = new InvitationService(env.endpoint);

export default service;
